<template>
  <router-link :to="to" :class="link_class"> <slot></slot> </router-link>
</template>
<script>
  export default {
    props: {
      to: {
        type: [Object, String],
        required: true
      },
      routes: {
        type: Array,
        default: () => []
      }
    },

    computed: {
      is_multiple() {
        return this.routes.length > 0;
      },
      is_active() {
        const matched = this.$route.matched;
        const last_match = matched[matched.length - 1];
        const current_link = this.$router.resolve(this.to);
        if (this.is_multiple) {
          const routes = this.routes.map(item => this.$router.resolve(item));
          routes.push(current_link);
          return routes.some(item => last_match.regex.test(item.href));
        }

        return last_match.regex.test(current_link.href);
      },
      link_class() {
        return {
          'sidebar-menu__sub-link': true,
          'sidebar-menu__sub-link--active': this.is_active
        };
      }
    }
  };
</script>
